import { FormFieldGroup, FormInput, FormLabel, FormLabelDescription, FormTextarea } from '$components'
import { z } from 'zod'
import { Input } from './types'

export const detailsSchema = z.object({
  [Input.FirstName]: z.string()
    .min(1, { message: 'First name is required.' })
    .max(255, { message: 'First name must be less than 255 characters.' }),
  [Input.LastName]: z.string()
    .min(1, { message: 'Last name is required.' })
    .max(255, { message: 'Last name must be less than 255 characters.' }),
  [Input.Email]: z.string()
    .email({ message: 'Invalid email address.' })
    .max(320, { message: 'Email must be less than 320 characters.' }),
  [Input.Phone]: z.string()
    .min(1, { message: 'Phone number is required.' })
    .max(32, { message: 'Phone number must be less than 32 characters.' }),
  [Input.InternalNotes]: z.string()
    .max(2048, { message: 'Notes must be less than 2048 characters.' })
    .optional(),
})

export function DetailsStep() {
  return (
    <div className="flex flex-col gap-6">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.FirstName}>
          First Name
        </FormLabel>

        <FormInput
          name={Input.FirstName}
          placeholder="Enter client first name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.LastName}>
          Last Name
        </FormLabel>

        <FormInput
          name={Input.LastName}
          placeholder="Enter client last name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Email}>
          Email
        </FormLabel>

        <FormInput
          name={Input.Email}
          type="email"
          placeholder="Enter email address..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Phone}>
          Phone Number
        </FormLabel>

        <FormInput
          name={Input.Phone}
          placeholder="Enter phone number..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.InternalNotes}>
          Internal Notes
        </FormLabel>

        <FormLabelDescription>
          Add any internal notes about this client (only visible to you and your team).
        </FormLabelDescription>

        <FormTextarea
          name={Input.InternalNotes}
          placeholder="Enter any internal notes..."
        />
      </FormFieldGroup>
    </div>
  )
}
